var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.error !== null)?_c('div',[(_vm.error)?_c('ErrorDetail',{attrs:{"error":_vm.error}}):_c('Page404',{attrs:{"message":"That error was not found"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }